import React, { useCallback, useState } from 'react';

import { UserInvite } from '@/components/AccountPanel/components/UserInvite';
import { Scrollbar } from '@/components/Scrollbar';
import {
	AsaphDialog,
	AsaphDialogHeader,
	AsaphDialogHeaderButton,
} from '@/components/shared/Dialog';
import { Loader } from '@/components/shared/Loader';
import { PANEL_TRANSITION_TIMEOUT } from '@/config/constants';
import { useAuth } from '@/providers/AuthProvider';
import { useTeam } from '@/providers/TeamProvider';

import styles from './InviteTeamMemberDialog.module.scss';

export interface InviteTeamMemberDialogProps {
	open: boolean;
	onClose: () => void;
	onInviteSent?: (name: string) => void;
}

export const InviteTeamMemberDialog = ({
	open,
	onClose,
	onInviteSent,
}: InviteTeamMemberDialogProps) => {
	const { team } = useTeam();
	const { user } = useAuth();

	const [invitedMember, setInvitedTeamMember] = useState<string>();

	const handleInviteSent = (name: string) => {
		setInvitedTeamMember(name);
	};

	const handleClose = useCallback(() => {
		if (onInviteSent != null && invitedMember != null) {
			onInviteSent(invitedMember);
		}
		onClose();
	}, [invitedMember, onInviteSent, onClose]);

	if (!team || !team.members) {
		return <Loader />;
	}

	const self = team.members.find((member) => member?.user.id === user.id);

	return (
		<AsaphDialog open={open} onClose={handleClose}>
			<div className={styles['invite-team-member__toolbar']}>
				<AsaphDialogHeader
					leadingButton={{
						needsFadeIn: true,
						fadeTimeout: PANEL_TRANSITION_TIMEOUT,
						component: (
							<AsaphDialogHeaderButton
								type="text"
								label="Cancel"
								handlePress={handleClose}
							/>
						),
					}}
					title={{
						needsFadeIn: true,
						fadeTimeout: PANEL_TRANSITION_TIMEOUT,
						label: '',
					}}
					trailingButton={{
						needsFadeIn: true,
						fadeTimeout: PANEL_TRANSITION_TIMEOUT,
						component: null,
					}}
				/>
			</div>
			<section className={styles['invite-team-member__content']}>
				<Scrollbar
					className={styles['invite-team-member__content-container']}
				>
					<UserInvite
						canAssignAdmin={!!self?.roles.includes('teamAdmin')}
						onInviteSent={handleInviteSent}
					/>
				</Scrollbar>
			</section>
		</AsaphDialog>
	);
};
